import MediaPlayerHeader from './media-player-header-redux';

export default MediaPlayerHeader;